// App.js
import React, { useContext} from "react";
import { ToastContainer } from "react-toastify";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Rates from "./pages/Dashboard/Rates";
import Boxes from "./pages/Dashboard/Boxes";

import AuthContext from "./store/AuthCtx";
import Address from "./pages/Dashboard/Addresses";

function App() {
  const AuthCtx = useContext(AuthContext);

  return (
    <>
      <ToastContainer />

      <Routes>
        <Route path="/" element={<Login />} />
        {AuthCtx.isLoggedIn && (
          <Route path="/dashboard" element={<Dashboard />}>
            <Route path="/dashboard/rates" element={<Rates />} />
            <Route path="/dashboard/boxes" element={<Boxes />} />
            <Route path="/dashboard/address" element={<Address />} />
          </Route>
        )}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;
